import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Grid,
  Divider,
  Button,
} from "@mui/material";
import { useLocation, Link } from "react-router-dom";
import { dateFormatter } from "src/views/greeting/GreetingListView/DateFormate";

const ReturnDetails = () => {
  const location = useLocation();
  const { row } = location.state || {};

  if (!row) {
    return <Typography>No data provided.</Typography>;
  }

  // Format date safely

  return (
    <Card sx={{ maxWidth: "95%", margin: "auto", mt: 4, p: 2 }}>
      <CardContent>
        <Typography variant="h4" gutterBottom>
          Order Return Details
        </Typography>
        <Divider sx={{ mb: 2 }} />

        {/* General Info */}
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography>
              <strong>Order ID:</strong> {row?.ondcOrderId || "N/A"}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>
              <strong>Transaction ID:</strong> {row?.transactionId || "N/A"}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>
              <strong>Status:</strong> {row?.order?.state || "N/A"}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>
              <strong>Created At:</strong>{" "}
              {dateFormatter(row?.createdAt || row?.order?.created_at)}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>
              <strong>Updated At:</strong>{" "}
              {dateFormatter(row?.updatedAt || row?.order?.updated_at)}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>
              <strong>Settlement Initiated:</strong>{" "}
              {row?.isSettleInitiated ? "Yes" : "No"}
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />

        {/* Customer Info */}
        <Typography variant="h6">Customer Info</Typography>
        <Box sx={{ my: 1, pl: 2, borderLeft: "3px solid #2196f3" }}>
          <Typography>
            <strong>Name:</strong> {row?.order?.billing?.name || "N/A"}
          </Typography>
          <Typography>
            <strong>Phone:</strong> {row?.order?.billing?.phone || "N/A"}
          </Typography>
          <Typography>
            <strong>Email:</strong> {row?.order?.billing?.email || "N/A"}
          </Typography>
          <Typography>
            <strong>Address:</strong>{" "}
            {[
              row?.order?.billing?.address?.building,
              row?.order?.billing?.address?.locality,
              row?.order?.billing?.address?.city,
              row?.order?.billing?.address?.state,
              row?.order?.billing?.address?.country,
              row?.order?.billing?.address?.area_code,
            ]
              .filter(Boolean)
              .join(", ") || "N/A"}
          </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />
        <Typography variant="h6">Payment</Typography>
        <Box sx={{ my: 1, pl: 2, borderLeft: "3px solid #f57c00" }}>
          <Typography>
            <strong>Total Amount:</strong> ₹
            {row?.order?.quote?.price?.value || "N/A"}{" "}
            {row?.order?.quote?.price?.currency || ""}
          </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Fulfillment Info */}
        {/* <Typography variant="h6">Fulfillment</Typography>
        {row?.fulfillments?.length > 0 ? (
          row.fulfillments.map((f, idx) => (
            <Box
              key={idx}
              sx={{ my: 1, pl: 2, borderLeft: "3px dashed #9c27b0" }}
            >
              <Typography>
                <strong>Provider:</strong>{" "}
                {f?.["@ondc/org/provider_name"] || "N/A"}
              </Typography>
              <Typography>
                <strong>Type:</strong> {f?.type || "N/A"}
              </Typography>
            </Box>
          ))
        ) : (
          <Typography>No fulfillment info found.</Typography>
        )} */}

        {/* Back button */}
        <Box sx={{ mb: 2, mt: 4 }}>
          <Button
            component={Link}
            to="/app/management/ondc-order"
            variant="outlined"
            color="primary"
          >
            Back
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ReturnDetails;
